var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        ref: "s1",
        staticClass: "user-drop-menu",
        class: { active: _vm.user_drop_menu_show },
      },
      [_vm._t("default")],
      2
    ),
    _c("div", {
      staticClass: "mock",
      class: { active: _vm.user_drop_menu_show },
      on: { click: _vm.onClose },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }